import { Order, OrderFilterData } from '@api/types';
import { OrderListItem, Table, TablePagination, useOrderListContext } from '@components';

type OrderListProps = {
  //define your props here
};

export const OrderList: React.FC<OrderListProps> = (props: OrderListProps) => {
  const {
    id,
    itemsPerPage,
    items,
    isError,
    isWorking,
    offset,
    totalCount,
    filteredColumns,
    visibleColumnNames,
    isFetching,
    filters,
  } = useOrderListContext();
  return (
    <>
      <Table
        headerColumns={filteredColumns}
        itemsOnPage={itemsPerPage}
        isWorking={isWorking}
        isError={isError}
        list={items as Order[]}
        renderRow={(order) => (
          <OrderListItem
            order={order}
            key={order.id}
            filters={filters as OrderFilterData}
            isWorking={isWorking}
            visibleColumnNames={visibleColumnNames}
            filteredColumns={filteredColumns}
          />
        )}
      />
      <TablePagination
        id={id}
        start={offset}
        totalCount={totalCount}
        itemsPerPage={itemsPerPage}
        isWorking={isFetching}
      />
    </>
  );
};
